export default __webpack_public_path__ + "static/media/Delete_Dark.6cbbbace.svg";